import { useRef } from 'react';
import Skeleton from 'react-loading-skeleton';

interface iProps {
	loading: boolean;
	data: string[];
	filters: string[];
	setFilters: (filters: string[]) => void;
}

export const FilterScouts = ({
	data,
	loading,
	filters,
	setFilters,
}: iProps) => {
	let isDragging = false;
	let startX: number;
	let scrollLeft: number;
	const tabListRef = useRef<HTMLUListElement>(null);
	const activeTabRef = useRef<HTMLLIElement>(null);

	const handleMouseDown = (e: React.MouseEvent) => {
		isDragging = true;
		startX = e.pageX - (tabListRef.current?.offsetLeft || 0);
		scrollLeft = tabListRef.current?.scrollLeft || 0;
		document.body.style.userSelect = 'none';
	};
	const handleMouseLeave = () => {
		isDragging = false;
		document.body.style.userSelect = '';
	};
	const handleMouseUp = () => {
		isDragging = false;
		document.body.style.userSelect = '';
	};
	const handleMouseMove = (e: React.MouseEvent) => {
		if (!isDragging) return;
		e.preventDefault();
		const x = e.pageX - (tabListRef.current?.offsetLeft || 0);
		const walk = (x - startX) * 2;
		if (tabListRef.current) {
			tabListRef.current.scrollLeft = scrollLeft - walk;
		}
	};

	const toggleScoutSelection = (scoutName: string) => {
		setFilters([scoutName]);
	};

	return (
		<div className="flex flex-row px-3 pb-3">
			{loading ? (
				<div>
					<Skeleton className="w-full h-[543px] rounded-lg" />
				</div>
			) : (
				<ul
					className="flex mb-0 list-none flex-row overflow-x-auto whitespace-nowrap scrollbar-hide"
					role="tablist6"
					ref={tabListRef}
					onMouseDown={handleMouseDown}
					onMouseLeave={handleMouseLeave}
					onMouseUp={handleMouseUp}
					onMouseMove={handleMouseMove}
				>
					{data.map((tabsTitle, index) => (
						<li
							key={index}
							className={
								'flex gap-2 p-2 flex-shrink-0 min-w-fit cursor-pointer select-none font-bahnschrift transition-all duration-300 transform ' +
								(filters.includes(tabsTitle)
									? 'border-solid border-b border-primary translate-x-0'
									: '')
							}
							ref={
								filters.includes(tabsTitle)
									? activeTabRef
									: null
							}
						>
							<a
								className={
									'text-sm px-0.5 text-left font-bahnschrift ' +
									(filters.includes(tabsTitle)
										? 'text-primary'
										: 'text-[#979797]')
								}
								onClick={(e) => {
									e.stopPropagation();
									e.preventDefault();
									toggleScoutSelection(tabsTitle);
								}}
								data-toggle="tab"
								href={`#${tabsTitle}`}
								role="tablist6"
								aria-selected={filters.includes(tabsTitle)}
							>
								{tabsTitle}
							</a>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};
